/**
 * Base API service class.
 * Provides shared auth, headers, and error handling for all API services.
 * Extend this class instead of duplicating getHeaders/setAuthProvider in every service.
 */

import { createLogger } from '@/lib/logger';
import { getCorrelationId } from '@/lib/correlationId';

type Logger = ReturnType<typeof createLogger>;

export class BaseApiService {
  protected baseUrl: string;
  protected log: Logger;
  private getAccessToken: (() => Promise<string | null>) | null = null;

  constructor(baseUrl: string, loggerName: string) {
    this.baseUrl = baseUrl;
    this.log = createLogger(loggerName);
  }

  setAuthProvider(getAccessToken: () => Promise<string | null>) {
    this.getAccessToken = getAccessToken;
  }

  protected async getHeaders(): Promise<HeadersInit> {
    const headers: HeadersInit = {
      'Content-Type': 'application/json',
      'X-Correlation-Id': getCorrelationId(),
    };

    if (this.getAccessToken) {
      const token = await this.getAccessToken();
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }
    }

    return headers;
  }
}
